import {
  useGetPermissions,
  usePermissions,
  useUpsertRole,
} from '@dispatch/shared/hooks';
import { Role, RoleUpsertBody } from '@dispatch/shared/types';
import { useCurrentUser } from '@dispatch/web/auth';
import { RoleDetails } from '@dispatch/web/features/roles';
import { useNotificationMutationFactory } from '@dispatch/web/ui';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

const RoleCreatePage = () => {
  const outletContext: {
    refetch: () => Promise<void>;
  } = useOutletContext();
  const navigate = useNavigate();
  const id = uuidv4();
  const { data: permissions } = useGetPermissions();
  const { permissions: userPermissions } = usePermissions();
  const { tenantId } = useCurrentUser();
  const { notifySuccess } = useNotificationMutationFactory('Role', 'create');
  const onSuccess = () => {
    notifySuccess();
    outletContext?.refetch?.();
    navigate(`/admin/roles/${id}`);
  };

  const { upsertRole } = useUpsertRole(id, onSuccess);

  const handleSave = (values: Partial<Role>) => {
    const postBody: RoleUpsertBody = {
      ...values,
      id,
      tenantId: tenantId || '',
      application: 'Dispatch',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      permissions: values.permissions as string[],
    };

    upsertRole(postBody);
  };

  return (
    <RoleDetails
      onSave={handleSave}
      status={'success'}
      permissions={permissions?.data || []}
      userPermissions={userPermissions}
    />
  );
};

export default RoleCreatePage;
